<div class="window-button-container">
    <button class="minimizebutton lower"
        [ngbTooltip]="get_Minimized() ? 'Click to show all information.' : 'Click to show compact information.'"
        [ngClass]="{'fancy-button':get_Minimized()}" (click)="minimize()" *ngIf="creature==='Character'">
        <i class='bi-arrows-collapse' *ngIf="get_Minimized()"></i>
        <i class='bi-arrows-expand' *ngIf="!get_Minimized()"></i>
    </button>
    <button class="tilemodebutton" [ngClass]="{'fancy-button':get_TileMode()}" (click)="toggle_TileMode()"
        [ngbTooltip]="get_TileMode() ? 'Click to enable list layout' : 'Click to enable tiled layout'">
        <!--Content is css only-->
        <div>
            <div> </div>
            <div> </div>
            <div> </div>
            <div> </div>
        </div>
    </button>
</div>
<div id="{{creature}}-skills-height" class="attributeBox">
    <div class="loading" *ngIf="still_loading()">Loading</div>
    <ng-container *ngIf="!still_loading()">
        <header class="sectionHeader box-header">Perception</header>
        <ng-container *ngFor="let activityGains of [get_OwnedActivities()]; trackBy:trackByIndex;">
            <ng-container *ngFor="let skill of get_Skills('', {type: 'Perception'}); trackBy:trackByIndex;">
                <app-skill [creature]="creature" [skill]=skill [minimized]="get_Minimized()"
                    [relatedActivityGains]="get_SkillActivities(activityGains, skill.name)"
                    [showAction]="get_ShowAction()" (showActionMessage)="receive_ActionMessage($event)"></app-skill>
            </ng-container>
            <div class="vlist">
                <header class="subsectionHeader">Senses</header>
                <div class="list-item lower" [ngbPopover]="get_SenseDesc(sense)"
                    *ngFor="let sense of get_Senses(); trackBy:trackByIndex;">
                    {{sense}}
                </div>
            </div>
            <app-tags [creature]="creature" [objectName]="'Senses'" [showTraits]=true [showFeats]=true [showItems]=true
                [showActivities]=true [showConditions]=true></app-tags>
            <ng-container *ngIf="creature==='Familiar'">
                <header class="sectionHeader box-header">Attack Rolls</header>
                <app-tags [creature]="creature" [objectName]="'Attacks'" [showTraits]=true [showFeats]=true
                    [showItems]=true [showActivities]=true [showConditions]=true></app-tags>
                <ng-container
                    *ngFor="let skill of get_Skills('', {type: 'Familiar Proficiency'}); trackBy:trackByIndex;">
                    <app-skill [creature]="creature" [minimized]="get_Minimized()" [skill]=skill></app-skill>
                </ng-container>
            </ng-container>
            <ng-template #SpeedEffectsPopoverContent>
                <div class="fullsize-only newrow">
                    <app-objectEffects [creature]="creature" [objectName]="'Land Speed'"></app-objectEffects>
                </div>
                <div class="fullsize-only newrow">
                    <app-objectEffects [creature]="creature" [objectName]="'Burrow Speed'"></app-objectEffects>
                </div>
                <div class="fullsize-only newrow">
                    <app-objectEffects [creature]="creature" [objectName]="'Climb Speed'"></app-objectEffects>
                </div>
                <div class="fullsize-only newrow">
                    <app-objectEffects [creature]="creature" [objectName]="'Fly Speed'"></app-objectEffects>
                </div>
                <div class="fullsize-only newrow">
                    <app-objectEffects [creature]="creature" [objectName]="'Swim Speed'"></app-objectEffects>
                </div>
            </ng-template>
            <header class="sectionHeader box-header">
                <span class="fullsize-only" [ngbPopover]="SpeedEffectsPopoverContent" #SpeedEffectsPopover="ngbPopover"
                    triggers="click">
                    <i [ngbTooltip]="!SpeedEffectsPopover.isOpen() ? 'Edit effects' : ''"
                        class='bi-lightning-charge'></i>
                </span>
                Movement
            </header>
            <ng-container *ngFor="let speed of get_Speeds(); trackBy:trackByIndex;">
                <div class="list-item"
                    *ngFor="let calculatedSpeed of [speed.value(get_Creature(), characterService, effectsService)]; trackBy:trackByIndex;">
                    <div class="newrow">
                        <span>
                            <strong>{{(speed.name==="Speed") ? "All Speeds" : speed.name}}</strong>
                        </span>
                        <span>
                            <div class="value" [ngbPopover]="calculatedSpeed.explain" [ngClass]="{'penalty':speed.penalties(get_Creature(), effectsService, speed.name, true),
                        'bonus':speed.bonuses(get_Creature(), effectsService, speed.name, true),
                        'absolute':speed.absolutes(get_Creature(), effectsService, speed.name, true).length}">
                                {{calculatedSpeed.result}}
                            </div>
                        </span>
                    </div>
                    <app-tags [creature]="creature" [objectName]=speed.name [showTraits]=true [showFeats]=true
                        [showItems]=true [showActivities]=true [showConditions]=true
                        [specialEffects]="speed.absolutes(get_Creature(), effectsService, speed.name, true).concat(speed.relatives(get_Creature(), effectsService, speed.name, true))">
                    </app-tags>
                </div>
            </ng-container>
            <app-tags [creature]="creature" [objectName]="'Movement'" [showTraits]=true [showFeats]=true
                [showItems]=true [showActivities]=true [showConditions]=true [showEffects]=true></app-tags>
            <header class="sectionHeader box-header">Skills</header>
            <!--Skill Increases-->
            <ng-container *ngFor="let choice of get_SkillChoices(); trackBy:trackByIndex;">
                <app-skillchoice (showSkillChoiceMessage)="receive_ChoiceMessage($event)" [showTitle]="true"
                    [showContent]="true" [choice]="choice" [showChoice]="get_ShowList()">
                </app-skillchoice>
            </ng-container>
            <app-tags [creature]="creature" [objectName]="'Skills'" [showTraits]=true [showFeats]=true [showItems]=true
                [showActivities]=true [showConditions]=true [showEffects]=true></app-tags>
            <app-tags [creature]="creature" [objectName]="'Skill Checks'" [showTraits]=true [showFeats]=true
                [showItems]=true [showActivities]=true [showConditions]=true [showEffects]=true></app-tags>
            <ng-container *ngFor="let skill of get_Skills('', {type: 'Skill'}); trackBy:trackByIndex;">
                <app-skill [creature]="creature" [skill]=skill [minimized]="get_Minimized()"
                    [relatedActivityGains]="get_SkillActivities(activityGains, skill.name)"
                    [showAction]="get_ShowAction()" (showActionMessage)="receive_ActionMessage($event)"></app-skill>
            </ng-container>
        </ng-container>
    </ng-container>
</div>